/**
 * Configuración de la aplicación cargada en tiempo de ejecución
 * Este archivo permite cambiar la configuración sin recompilar la aplicación
 */

export interface AppConfig {
  apiUrl: string;
  siteName?: string;
}

let appConfig: AppConfig | null = null;

/**
 * Carga la configuración desde el archivo config.json en la carpeta public
 * Este archivo se puede modificar en cada sitio sin necesidad de recompilar
 */
export const loadAppConfig = async (): Promise<AppConfig> => {
  if (appConfig) {
    return appConfig;
  }

  try {
    // Intentar cargar la configuración desde el archivo config.json
    const response = await fetch('/config.json');
    if (!response.ok) {
      throw new Error(`Error al cargar config.json: ${response.status}`);
    }
    const config = await response.json();
    
    // Validar que tenga la URL de la API
    if (!config.apiUrl) {
      throw new Error('config.json debe contener la propiedad apiUrl');
    }

    appConfig = {
      apiUrl: config.apiUrl,
      siteName: config.siteName || 'Neos eOne',
    };

    console.log('✅ Configuración cargada:', appConfig);
    return appConfig;
  } catch (error) {
    console.error('❌ Error al cargar config.json, usando valores por defecto:', error);
    
    // Valores por defecto si no se puede cargar el archivo
    appConfig = {
      apiUrl: process.env.REACT_APP_API_URL || 'https://localhost:3000',
      siteName: process.env.REACT_APP_SITE_NAME || 'Neos eOne',
    };
    
    return appConfig;
  }
};

/**
 * Obtiene la configuración de la aplicación
 * Si no está cargada, la carga primero
 */
export const getAppConfig = async (): Promise<AppConfig> => {
  return await loadAppConfig(); // Retorna la configuración cargada
};

/**
 * Obtiene la URL de la API de forma síncrona (solo si ya fue cargada)
 * Útil para casos donde no se puede usar async/await
 */
export const getApiUrl = (): string => {
  if (appConfig) {
    return appConfig.apiUrl;
  }
  // Fallback a variable de entorno o valor por defecto
  return process.env.REACT_APP_API_URL || 'https://localhost:3000';
};

/**
 * Obtiene el nombre del sitio de forma síncrona (solo si ya fue cargada)
 * Útil para casos donde no se puede usar async/await
 */
export const getSiteName = (): string => {
  if (appConfig) {
    return appConfig.siteName || 'Neos eOne';
  }
  // Fallback a variable de entorno o valor por defecto
  return process.env.REACT_APP_SITE_NAME || 'Neos eOne';
};


